<template>
  <PageTemplate :class="componentClass" :title="metaTitle">
    <figure class="about-custom-view-img mb-2">
      <img
        v-if="parsedImg"
        loading="lazy"
        :src="parsedImg"
        class="rounded-xl"
      />
    </figure>

    <div
      v-if="item.text"
      class="ck-content font-weight-medium mb-4"
      v-html="item.text"
    ></div>

    <div class="mt-10">
      <BannerWidget
        category="Retângulo"
        type="carousel"
        :items-to-show="{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }"
      />
    </div>
  </PageTemplate>
</template>

<script>
import BannerWidget from "../components/widgets/BannerWidget.vue";
import PageTemplate from "../components/templates/PageTemplate.vue";

/**
 * $route.meta = {
 *   mod: string; // Chave do módulo.
 *   ?title: string | (component) => string; // Título da página.
 *   ?params: Record<string, string> | (component) => Record<string, string>; // Parametros da requisição de dados
 * }
 */
export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    metaTitle() {
      const metaTitle = this.$route.meta.title;

      if (!metaTitle) {
        return this.$route.name;
      }

      if (typeof metaTitle === "function") {
        return metaTitle(this);
      } else {
        return metaTitle;
      }
    },
    mod() {
      return this.$route.meta.mod;
    },
    item() {
      return this.$rest(this.mod).item;
    },
    parsedTitle() {
      return this.item.title?.replace(/\\"/g, '"');
    },
    parsedImg() {
      const path = this.item.img;

      return path ? this.files + path + "?resize=1&w=600" : null;
    },

    componentClass() {
      return "about-custom-view";
    },
  },
  methods: {
    getData() {
      this.$rest(this.mod)
        .get({
          save: (state, data) => (state.item = data),
        })
        .catch(() => this.$router.replace({ path: "/erro404" }))
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    mod() {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
  components: {
    BannerWidget,
    PageTemplate,
  },
};
</script>

<style lang="scss">
.about-custom-view {
  .about-custom-view-img {
    float: right;

    img {
      width: 100%;
      max-width: 540px;
    }
  }
}

@media screen and (max-width: 960px) {
  .about-custom-view-img {
    float: none !important;
    display: flex;
    justify-content: center;
  }
}
</style>
